import { ControlledSelectField } from 'components/Form';
import { ModalDialog } from 'components/ModalDialog';
import { UerChapter, UerClassifier } from 'constantsProject';
import { cnMixSpace, IconWarning, Informer } from 'uikit';
import { requiredBaseRule } from 'utils/constants';

import { useForm } from 'react-hook-form';

import type { IUpdateCatalogUerBaseCostPropertiesForm } from './hooks';

const uerChaptersItems = Object.entries(UerChapter).map(([key, value]) => ({ id: key, label: value }));
const uerClassifierItems = Object.entries(UerClassifier).map(([key, value]) => ({ id: key, label: value }));

interface IUpdateCatalogUerBaseCostPropertiesModalProps {
    onClose: () => void;
    makeRequest: (form: IUpdateCatalogUerBaseCostPropertiesForm) => void;
}

export const UpdateCatalogUerBaseCostPropertiesModal = ({
    onClose,
    makeRequest,
}: IUpdateCatalogUerBaseCostPropertiesModalProps) => {
    const {
        control,
        handleSubmit,
        formState: { isDirty },
    } = useForm<IUpdateCatalogUerBaseCostPropertiesForm>();

    return (
        <ModalDialog
            isOpen
            title="массовое заполнение расценок"
            onClose={onClose}
            isOnClickOutsideDisable
            withTitleCloseButton
            bodyWidth={520}
            onConfirm={handleSubmit(makeRequest)}
            btnConfirmDisabled={!isDirty}
            btnConfirmLabel="Применить"
        >
            <div className={cnMixSpace({ p: 'l' })}>
                <Informer
                    view="filled"
                    status="warning"
                    label="Выбранные параметры обновят ранее заданные значения в расценках"
                    icon={IconWarning}
                    size="s"
                    className={cnMixSpace({
                        mB: 'xl',
                    })}
                />

                <ControlledSelectField
                    name="uerClassifier"
                    label="Тип УЕР"
                    control={control}
                    items={uerClassifierItems}
                    className={cnMixSpace({
                        mB: 's',
                    })}
                    rules={requiredBaseRule}
                />
                <ControlledSelectField
                    name="chapter"
                    label="Глава в расчете"
                    control={control}
                    items={uerChaptersItems}
                    rules={requiredBaseRule}
                />
            </div>
        </ModalDialog>
    );
};

UpdateCatalogUerBaseCostPropertiesModal.displayName = 'UpdateCatalogUerBaseCostPropertiesModal';
